export class AuthModel {
  username!: string;
  isSuccess!: boolean;
  result: any;
  message!: string;
 }
